import React from 'react';
import PropTypes from 'prop-types';
import Classes from './Classes.less';

/**
* Minimal renderer for a read only section, just applies the
* given section style and built in class.
*/
const SectionContainer = (props) => {
  return (
    <div className={Classes.sectionContainer}
      style={props.sectionStyle}>
        {props.children}
    </div>
  );
};
SectionContainer.displayName = 'SectionContainer';
SectionContainer.propTypes = {
  sectionStyle: PropTypes.object,
  children: PropTypes.node
};
export default SectionContainer;
